export default function (editor) {
  let wrapper;

  editor.TraitManager.addType("textarea", {
    createInput() {
      const t = document.createElement("textarea");
      t.style.height = "300px";
      t.value = this.getModelValue();
      return t;
    },
  });

  const wrapperUpdate = () => {
    wrapper = editor.getWrapper();
    wrapper &&
      wrapper.get("traits").add([
        {
          name: "data-page-script",
          type: "textarea",
          label: "Page script",
        },
      ]);
  };

  editor.on("storage:loaded", () => {
    wrapperUpdate();
  });

  editor.on("storage:start:store", data => {
    const script = wrapper.getAttributes()["data-page-script"] || "";
    if (script.length == 0) return;

    data.html = `<script id="pageScript">${script}</script>` + data.html;
  });

  editor.on("storage:end:load", data => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<html><body>${data.html}</body></html>`, "text/html");

    const script = doc.querySelector("script#pageScript");
    if (script) wrapper.addAttributes({ "data-page-script": script.innerHTML });
  });
}
